import { FederalStateFormI, ValidationSet } from '../../../../types/interface';
import { ValidationEnum } from 'utils/enums/validationEnums';

export const FederalStateValidationSet: ValidationSet<FederalStateFormI> = {
  state_name_en: [
    {
      type: ValidationEnum.REQUIRED,
      message: 'Please enter federal state name in English',
      key: 'validation.federal_state.state_name_en'
    }
  ],
  state_name_de: [
    {
      type: ValidationEnum.REQUIRED,
      message: 'Please enter federal state name in German',
      key: 'validation.federal_state.state_name_de'
    }
  ]
};
